<template>
  <div class="user-deal-container">
    <h1 class="title">关于我们</h1>

    <dl class="deal-section">
      <dd class="deal-item">Hello单身部落是一个真实、靠谱、高端的实名单身交友平台，用户多来自于一二线城市的名企名校，涵盖华为、腾讯、阿里、银行、通信运营商、医院、高校等企事业单位，毕业于国内外TOP知名院校如清华、北大、中大、交大、华工、哈工大等。</dd>
      <dd class="deal-item">平台借助线上系统、公众号、线下活动等方式，提供线上交友、情感咨询、婚恋课程、线下单身交友活动等服务，深度挖掘单身用户的问题并多方位的给予对应的系列解决方案。</dd>
      <dd class="deal-item">平台的创始团队均来自于互联网大厂，在技术、产品、运营等方面有着丰富的经验，希望能专注做好一个有深度、有服务、有口碑、有初心的平台。</dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: 'aboutUs'
}
</script>

<style lang="scss">
.user-deal-container {
  padding: 30px 40px 80px;
  .title {
    font-size: 32px;
    line-height: 44px;
    font-weight: bold;
    text-align: center;
  }
  .deal-section {
    margin-top: 30px;
    font-size: 22px;
    line-height: 44px;
    text-align: left;
  }
  .deal-item {
    color: #696969;
  }
}
</style>
